import { post } from '@/util/request'

export default {
    /**
     * 预警舆情
     * */
    list: query => post(`/warning/list`, query),
    /**
     * 国内热点、省内热点
     * */
    hotNews: query => post(`/warning/hotnews/list`, query),
    /**
     * 删除预警数据
     * @param query
     * @returns {*}
     */
    bulkData:query => post(`/monitor/keyword/bulk`,query),

    /**
     * 查看单条数据
     * @param query
     * @returns {*}
     */
    dataDetail:query => post(`/warning/detail`,query),
    hasJiaoban:query => post(`/report/checkAssignm`,query),//是否有交办信息
    getTag:query => post(`/report/dictionaryList`,query),//交办标签
    getTree:query => post(`/report/getCustTree`,query),//交办接收单位树
    addJiaoban:query => post(`/report/saveOrUpdateAssignm`,query),//添加交办
}
